import React, { PropTypes as T } from 'react';
import withDevice from '../../common/withDeviceHOC';

export class CustomNavigationItem extends React.Component {
  static propTypes = {
    text: T.string,
    url: T.string,
    openInTab: T.bool,
    isMobile: T.bool
  };

  renderIcon = () => {
    if (this.props.isMobile) {
      return <i className="custom-navigation__item--mobile-icon" />;
    }
    else {
      return '';
    }
  };

  render () {
    const target = this.props.openInTab ? '_blank' : '_self';
    const listClass = this.props.isMobile ? '' : 'custom-navigation__item';
    const linkClass = this.props.isMobile ? 'mobilemenu__link' : 'custom-navigation__item--link';
    const textClass = this.props.isMobile ? '' : 'custom-navigation__item--txt';

    return (
      <li className={listClass}>
        <a
          className={linkClass}
          href={this.props.url}
          target={target}
          rel="nofollow"
          data-component="custom-navigation-item"
        >
          <span className={textClass}>{this.props.text}</span>
          {this.renderIcon()}
        </a>
      </li>
    );
  }
}

export default withDevice(CustomNavigationItem);



// WEBPACK FOOTER //
// ./frontend/react/components/header/customnavigationitems/index.js